import React from 'react';

/**
 * Іконка «Оплата частинами» на Prom (фіолетово-жовтий логотип).
 * Використовується в адмінці замовлень біля типу оплати PROM_PAY_BY_PARTS.
 */
function PromPayByPartsIcon({ className = 'pr-1', size = 16, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      style={{ verticalAlign: 'middle', ...props.style }}
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#7B04DF"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2H2v9h4.5V6.5H11V2ZM6.5 13v4.5H11V22H2v-9h4.5Zm6.5 9h9v-9h-4.5v4.5H13V22Z"
      />
      <path fill="#FFD400" d="M13 2h9v9h-4.5V6.5H13V2Z" />
    </svg>
  );
}

export default PromPayByPartsIcon;
